import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { add, remove } from '../../Actions/Favorites.action';

const HeartSvg = () => {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="none" stroke="currentColor" strokeWidth="2px" className="a"
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
    );
}

/**
 *
 * @param variant
 * @returns {Element}
 * @constructor
 */
const AddToFavorites = ({variant}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { articleNos } = useSelector((state) => state.favorites);
    let isInFavorites = articleNos.includes(variant.id);

    const addToFavorites = async () => {
        try {
            await setLoading(true);
            if (isInFavorites) {
                await dispatch(remove(variant.id));
            } else {
                await dispatch(add(variant.id));
            }
        } catch (error) {
            await setLoading(false);
            console.error('Error adding to favorites:', error);
        } finally {
            await setLoading(false);
        }
    };

    return (
        <div className={'favorites__add' + (isInFavorites ? ' is-added' : '')} onClick={() => addToFavorites()}>
            {!loading ?
                <HeartSvg /> :
                <div className="favorites__loading"></div>
            }
        </div>
    );
}

export default AddToFavorites;